import "../App.css";
import settingsIcon from "../photos/settings.svg";
import crossIcon from "../photos/cross-small.svg";
import { charCountColor } from "../utils/charCountColor.ts";

interface PlayerChipProps {
  name: string;
  charCount: number;
  hasSubmittedInstructions: boolean;
  isMe?: boolean;
  canKick?: boolean;
  onClick?: () => void;
}

const PlayerChip: React.FC<PlayerChipProps> = ({
  name,
  charCount,
  hasSubmittedInstructions,
  isMe,
  canKick,
  onClick,
}) => {
  const isClickable = isMe || canKick;
  const trailingIcon = isMe ? settingsIcon : canKick ? crossIcon : null;
  const trailingAlt = isMe ? "Edit" : canKick ? "Remove" : "";

  return (
    <div
      className={`name-box ${hasSubmittedInstructions ? "" : "name-box--gray"}`}
      style={isMe ? { border: "2px solid #F42272", cursor: "pointer" } : canKick ? { cursor: "pointer" } : {}}
      onClick={isClickable ? onClick : undefined}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <p className="text-h4">{name}</p>
        {charCount > 0 && (
          <p className="text-h4" style={{ color: charCountColor(charCount) }}>
            {charCount}
          </p>
        )}
        {trailingIcon && (
          <img
            src={trailingIcon}
            alt={trailingAlt}
            style={{ width: 14, height: 14 }}
          />
        )}
      </div>
    </div>
  );
};

export default PlayerChip;
